// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "smartdown") return "" + chunkId + ".js";
	// return url for filenames based on template
	return "smartdown_" + chunkId + ".js";
};